import React from "react"
import { DATA_PROCESSING_ADDENDUM } from "../../constants"

class Comp extends React.PureComponent {
  render() {
    return (
      <div data-testid="data-processing-addendum">
        <div className="legal-component">
          <p className="privacy-policy-content-title">
            {DATA_PROCESSING_ADDENDUM}
          </p>
          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              In connection with the services offered by&nbsp;
            </span>
            <span className="privacy-policy-content-text">
              Kaizen Reporting<strong>&nbsp;</strong>
            </span>
            <span className="privacy-policy-content-text">
              Limited and its affiliates (“{/* */}
              <span className="privacy-policy-content-text">Kaizen</span>”),
              Kaizen may collect, process or handle personal data relating to
              individuals (the “{/* */}
              <span className="privacy-policy-content-text">Personal Data</span>
              {/* */}
              ”) on behalf of its customers and their affiliates, where
              applicable (“
              <span className="privacy-policy-content-text">customer</span>”).
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              Although Kaizen’s relationship with its customers is typically
              governed by terms and conditions and/or a master services
              agreement and/or the Hub Terms and Conditions of Service, which
              includes order forms, schedules and addenda (together the “{/* */}
              <span className="privacy-policy-content-text">Agreement</span>”),
              Kaizen is also legally bound under the UK General Data Protection
              Regulation (the “{/* */}
              <span className="privacy-policy-content-text">GDPR</span>”){" "}
              concerning the manner in which it collects, uses, and processes
              Personal Data. This Policy describes Kaizen’s commitment to the
              processing of Personal Data under the GDPR.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              1.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Appropriate Technical and Organizational Measures
                </span>
              </u>
              . When Kaizen processes Personal Data on behalf of a customer,
              Kaizen implements appropriate technical and organizational
              measures to satisfy the requirements of the GDPR, to ensure the
              level of security of Personal Data is appropriate to the level of
              risk, and to help ensure the protection of the rights of the data
              subject.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              2.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Subprocessing
                </span>
                {/* */}.
              </u>{" "}
              Customers may provide Kaizen specific or general written
              authorisation to utilize subprocessors. Kaizen requires that each
              of its subprocessors that may have access to Personal Data through
              Kaizen agrees to provide at least the same level of protection as
              is described in this Policy. To the extent required by law, Kaizen
              remains liable to its customers for any actions by its
              subprocessors that impact any rights guaranteed under the GDPR. If
              you would like further information about the service providers
              that we use from time to time to subprocess Personal Data, please
              contact Kaizen at&nbsp;
            </span>
            <a href="mailto:enquiries@kaizenreporting.com">
              <span className="privacy-policy-content-text">
                enquiries@kaizenreporting.com
              </span>
            </a>
            <span className="privacy-policy-content-text">.</span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              3.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Written Instructions
                </span>
              </u>
              . Kaizen only processes Personal Data in accordance with the terms
              (and to satisfy our obligations) set out in any Agreement, this
              Policy, the Kaizen Privacy Policy and any other written terms
              agreed with customer from time to time. The foregoing documents
              set out the subject-matter, duration, nature, purpose, types of
              Personal Data, categories of data subjects, and the obligations
              and rights of Kaizen’s customer relating to its processing of such
              Personal Data.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              4.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Transfers to non-EEA Countries
                </span>
              </u>
              . In connection with certain of its products and services, Kaizen
              confirms that Personal Data may be transmitted outside of the EEA.
              However, Kaizen will only transfer Personal Data provided it has a
              legal basis to do so under the GDPR, such as by offering to
              customers the Controller-Processor Standard Contractual Clauses..
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              5.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Confidentiality
                </span>
              </u>
              . Kaizen requires that the people it authorizes to process
              Personal Data are under appropriate obligations of
              confidentiality.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              6.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Cooperation Concerning Data Subjects
                </span>
              </u>
              . Kaizen cooperates with the reasonable requests of its customers
              (at the customer’s reasonable expense) to help them fulfill their
              obligations under the GDPR to respond to requests by data subjects
              to access, modify, rectify, or remove their Personal Data.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              7.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Cooperation Concerning Customer Documentation
                </span>
              </u>
              . Kaizen cooperates with the reasonable requests of its customers
              to provide information necessary to demonstrate compliance with
              this Policy and the GDPR or to conduct audits of the Personal Data
              held by Kaizen that was received from the customer. Kaizen will
              typically agree to such audits on the following basis: (a) audits
              may only occur once per calendar year and during normal business
              hours, and only after reasonable notice to Kaizen (not less than
              30 business days); (b) audits will be conducted by customer or an
              appropriate independent auditor appointed by customer (not being a
              competitor of Kaizen) to conduct audits, in a manner that does not
              have any adverse impact on Kaizen’s normal business operations;
              (c) customer and/or its representatives will comply with Kaizen’s
              standard safety, confidentiality and security procedures in
              conducting any such audits and shall not have access to any
              proprietary or third party information or data; and (d) any
              records, data or information accessed by the Company and/or its
              representatives in the performance of any such audit will be
              deemed to be the confidential information of Kaizen, as
              applicable, and may be used for no other reason than to assess
              Kaizen’s compliance with the terms of this Policy (in connection
              with the foregoing, Kaizen may require customer and and/or its
              representatives to enter into a customary confidentiality
              agreement prior to any such audit); (e) to the extent any such
              audit incurs or is reasonably likely to incur in excess of 2 hours
              of Kaizen personnel time, Kaizen shall be entitled to charge
              customer Kaizen standard day rates for any such excess hours.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              8.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Personal Data Breach
                </span>
              </u>
              . In the event of a Personal Data breach under the GDPR, Kaizen
              will notify its applicable customers without undue delay after
              becoming aware of the breach. Such notification(s) may be
              delivered to an email address provided by customer or, at Kaizen’s
              discretion, by direct communication (for example, by phone call or
              an in-person meeting). Customer is responsible for ensuring that
              any email address provided by customer is current and valid.
              Kaizen will take reasonable steps to provide its customers with
              information that they may reasonably require to comply with their
              obligations to notify impacted data subjects or supervisory
              authorities.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              9.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Deletion of Data; Termination and Variation
                </span>
              </u>
              . At the termination of a customer’s relationship with Kaizen,
              Kaizen will delete or return all Personal Data to our customer,
              unless Kaizen is permitted to retain it or is otherwise required
              to retain it by applicable laws, regulations or bona fide audit
              and compliance policies. Where applicable, Kaizen reserves the
              right to charge a reasonable fee to comply with any customer’s
              request to return Personal Data. Kaizen reserves the right to
              reasonably amend and update this Policy from time to time. Kaizen
              will give no less than 30 days’ notice of any such changes, which
              shall be included on the Kaizen website.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              10.{" "}
              <u>
                <span className="privacy-policy-content-text">
                  Governing Law
                </span>
              </u>
              . This Policy shall be governed by the laws of England and Wales
              and subject to the jurisdiction of English courts and otherwise
              subject to the limitations and remedies expressly set out in the
              Agreement.
            </span>
          </p>

          <p className="privacy-policy-content-text">
            <span className="privacy-policy-content-text">
              If you have any queries about this addendum please contact your
              usual account manager or Kaizen at&nbsp;
            </span>
            <a href="mailto:enquiries@kaizenreporting.com">
              <span className="privacy-policy-content-text">
                enquiries@kaizenreporting.com
              </span>
            </a>
            <span className="privacy-policy-content-text">.</span>
          </p>
        </div>
      </div>
    )
  }
}

export default Comp
